import { useEditor } from "@craftjs/core";
import React from "react";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { EditableLayerName } from "./EditableLayerName";
import {
  faArrowDown,
  faCaretDown,
  faCaretRight,
  faChevronRight,
  faClose,
  faEye,
  faFileArrowUp,
  faLink,
} from "@fortawesome/free-solid-svg-icons";

import { useLayer } from "../useLayer";

const Arrow = <FontAwesomeIcon size="xs" icon={faCaretRight} />;
const Eye = <FontAwesomeIcon icon={faEye} />;
const Linked = <FontAwesomeIcon icon={faLink} />;

const StyledDiv = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 4px 10px;
  background: ${(props) =>
    props.selected ? "#623CE7 !important" : "transparent"};
  color: ${(props) => (props.selected ? "#fff" : "#000")};
  border-radius: 4px;
  svg {
    color: ${(props) => (props.selected ? "#fff" : "#000")};
  }
  &:hover {
    background: rgb(230, 230, 230);
  }
  .inner {
    flex: 1;
    display: flex;
    > div {
      padding: 0px;
      flex: 1;
      display: flex;
      margin-left: ${(props) => props.depth * 10}px;
      align-items: center;
      div.layer-name {
        flex: 1;
        h2 {
          font-size: 0.75rem;
          line-height: 1rem;
        }
      }
    }
  }
`;

const Expand = styled.a`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: 0.4s cubic-bezier(0.19, 1, 0.22, 1);
  transform: rotate(${(props) => (props.expanded ? 90 : 0)}deg);
  opacity: 0.7;

  svg {
    width: 10px;
    height: 10px;
  }
`;

const Hide = styled.a`
  width: 14px;
  height: 14px;
  margin-right: 10px;
  position: relative;
  transition: 0.4s cubic-bezier(0.19, 1, 0.22, 1);
  cursor: pointer;

  svg {
    width: 100%;
    height: 100%;
    object-fit: contain;
    opacity: ${(props) => (props.isHidden ? 0.2 : 1)};
  }
  &:after {
    content: " ";
    width: 2px;
    height: ${(props) => (props.isHidden ? 100 : 0)}%;
    position: absolute;
    left: 2px;
    top: 3px;
    background: ${(props) => (props.selected ? "#fff" : "#808184")};
    transform: rotate(-45deg);
    transition: 0.4s cubic-bezier(0.19, 1, 0.22, 1);
    transform-origin: 0% 0%;
    opacity: ${(props) => (props.isHidden ? 0.4 : 1)};
  }
`;

const TopLevelIndicator = styled.div`
  margin-left: -22px;
  margin-right: 10px;

  svg {
    width: 12px;
    height: 12px;
  }
`;

export const DefaultLayerHeader = () => {
  const {
    id,
    depth,
    expanded,
    hovered,
    children,
    connectors: { drag, layerHeader },
    actions: { toggleLayer },
  } = useLayer((layer) => {
    return {
      hovered: layer.event.hovered,
      expanded: layer.expanded,
    };
  });

  const { hidden, actions, selected, topLevel } = useEditor((state, query) => {
    // TODO: handle multiple selected elements
    const selected = query.getEvent("selected").first() === id;

    return {
      hidden: state.nodes[id] && state.nodes[id].data.hidden,
      selected,
      topLevel: query.node(id).isTopLevelCanvas(),
    };
  });

  return (
    <StyledDiv
      selected={selected}
      hovered={hovered}
      ref={drag}
      depth={depth}
      data-grigora-layer-id={id}
    >
      {/* <Hide
        selected={selected}
        isHidden={hidden}
        onClick={() => actions.setHidden(id, !hidden)}
      >
        {Eye}
      </Hide> */}
      <div className="inner">
        <div ref={layerHeader}>
          {topLevel ? <TopLevelIndicator>{Linked}</TopLevelIndicator> : null}
          {children && children.length ? (
            <div
              className="w-[15px] h-[15px] mr-[3px]"
              onMouseDown={() => toggleLayer()}
            >
              <Expand expanded={expanded}>{Arrow}</Expand>
            </div>
          ) : (
            <div className="w-[15px] h-[15px] mr-[3px]"></div>
          )}
          <div className="layer-name s">
            <EditableLayerName />
          </div>

          {/* {children && children.length ? (
              <div className="w-[15px] h-[15px]">
              <Expand expanded={expanded} onMouseDown={() => toggleLayer()}>
                {Arrow}
              </Expand>
              </div>
            ) : null} */}
        </div>
      </div>
    </StyledDiv>
  );
};
